import _eol from "eol";
import _convertWordMapToSubtitles from "../functions/special/convertWordMapToSubtitles.js";
import _convertWordMapToTranscript from "../functions/special/convertWordMapToTranscript.js";
import _getFormatOptions from "../functions/helpers/getFormatOptions.js";
import _Event from "../classes/event.js";
const Event = _Event;
const getFormatOptions = _getFormatOptions;
const convertWordMapToTranscript = _convertWordMapToTranscript;
const convertWordMapToSubtitles = _convertWordMapToSubtitles;
const eol = _eol;
export default {
  decode: function (input, options) {
    let events = [],
      wordMap = [],
      decodingOptions = getFormatOptions(options.formatOptions);

    // Input may not be valid JSON — the whisper filter can output
    // newline-delimited JSON objects instead of a proper array.
    // Try parsing as-is first, then fix it otherwise if needed.
    let fileJson;
    try {
      fileJson = JSON.parse(input);
    } catch {
      // Whisper JSON may be invalid: objects are newline-delimited instead
      // of in a comma-separated array, and the text property may contain
      // unescaped double quotes or other problematic characters.
      let lines = eol.split(input.trim()).filter(line => line.trim().length > 0);
      let fixedLines = lines.map(line => {
        let trimmed = line.trim();
        // Fix unescaped quotes inside the "text" value
        let textMatch = trimmed.match(/^(.*"text"\s*:\s*")(.*)("\s*\}\s*)$/);
        if (textMatch) {
          let prefix = textMatch[1];
          let textContent = textMatch[2];
          let suffix = textMatch[3];
          // Escape any unescaped double quotes within the text content
          textContent = textContent.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
          // Undo double-escaping of already-escaped sequences
          textContent = textContent.replace(/\\\\\\\\/g, '\\\\').replace(/\\\\"/g, '\\"');
          trimmed = prefix + textContent + suffix;
        }
        return trimmed;
      });
      let fixed = '[' + fixedLines.join(',') + ']';
      fileJson = {
        transcription: JSON.parse(fixed)
      };
    }
    let importType = decodingOptions["Import Type"] || "subtitle";
    let maxLines = decodingOptions["Max Lines"] || 2;
    let maxChars = decodingOptions["Max Characters"] || 32;
    let transcription = fileJson.transcription || (Array.isArray(fileJson) ? fileJson : []);
    transcription.forEach(segment => {
      let text = (segment.text || "").trim();
      if (!text) return;
      let segStart, segEnd;
      if (segment.offsets) {
        segStart = segment.offsets.from / 1000;
        segEnd = segment.offsets.to / 1000;
      } else if (segment.timestamps) {
        segStart = parseTimestamp(segment.timestamps.from);
        segEnd = parseTimestamp(segment.timestamps.to);
      } else {
        /* start/end directly on segment, in milliseconds */
        segStart = (segment.start || 0) / 1000;
        segEnd = (segment.end || 0) / 1000;
      }

      /* Split segment text into individual words and distribute timing evenly.
         Keep SDH elements wrapped in () or [] as single tokens. */
      let words = text.match(/\([^)]*\)|\[[^\]]*\]|\S+/g) || [];
      let segDuration = segEnd - segStart;
      let wordDuration = words.length > 0 ? segDuration / words.length : segDuration;
      words.forEach((word, i) => {
        wordMap.push(new Event({
          start: segStart + i * wordDuration,
          end: segStart + (i + 1) * wordDuration,
          text: word,
          confidence: false,
          speakers: []
        }));
      });
    });

    // console.log(JSON.stringify(wordMap, null, 2));
    if (importType === "word map") {
      events = wordMap;
    } else if (importType === "transcription") {
      events = convertWordMapToTranscript(wordMap, maxLines, maxChars, options.window);
    } else {
      events = convertWordMapToSubtitles(wordMap, maxLines, maxChars, options.window);
    }
    return events;
  },
  encode: function (eventGroup, options) {
    throw new Error("Whisper transcription files are not supported for encoding by Closed Caption Creator.");
  },
  preProcess: {
    encode: function (eventGroup) {
      return eventGroup;
    },
    decode: function (input) {
      return input;
    }
  },
  postProcess: {
    encode: function (output) {
      return output;
    },
    decode: function (eventGroup) {
      eventGroup.events = eventGroup.events.filter((event, index, events) => {
        if (index !== 0) {
          return event.start !== events[index - 1].start;
        } else {
          return true;
        }
      });
      return eventGroup;
    }
  }
};
function parseTimestamp(ts) {
  /* Parse timestamp strings like "00:00:05.000" to seconds */
  if (typeof ts === "number") return ts;
  let parts = ts.split(":");
  let seconds = 0;
  if (parts.length === 3) {
    seconds = parseFloat(parts[0]) * 3600 + parseFloat(parts[1]) * 60 + parseFloat(parts[2]);
  } else if (parts.length === 2) {
    seconds = parseFloat(parts[0]) * 60 + parseFloat(parts[1]);
  } else {
    seconds = parseFloat(parts[0]);
  }
  return seconds;
}